<template>
	<div class="widget-content">
		<div
			v-if="widget.settings.media.mediaType === 'IMAGE'"
			class="widget-image"
			:style="{ backgroundImage: 'url(' + widget.settings.media.path + ')' }"
		/>
		<div
			v-if="widget.settings.media.mediaType === 'VIDEO'"
			class="widget-video"
		>
			<div class="widget-video-wrap">
				<video
					:src="widget.settings.media.path"
					:id="'video-' + widget.unique"
					preload
					loop
					muted
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: 'WidgetView',
	props: {
		widget: Object
	},
	mounted () {
		this.$nextTick(() => {
			this.initiateSlider()
		})
	},
	methods: {
		initiateSlider () {
			const currentElement = document.getElementById('video-' + this.widget.unique)
			if (currentElement) {
				currentElement.play()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.widget {

	&-content {
		height: 100%;
		width: 100%;
	}

	&-image {
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		height: 100%;
		width: 100%;
	}

	&-video {

		height: 100%;
		width: 100%;

		&-wrap {

			height: 100%;
			width: 100%;
			overflow: hidden;

			video {
				height: 100%;
				width:100%;
				object-fit: cover;
			}

		}

	}

}
</style>
